/* Services marketplace application form: client-side validation only.
   The form posts natively to /contact; submit is blocked only when a check
   fails, so Shopify's bot challenge and redirect keep working. */
(function () {
  var form = document.getElementById('OtcdSmApplyForm');
  if (!form) return;

  var EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  function check(moveFocus) {
    var ok = true;
    var first = null;

    form.querySelectorAll('input[required]').forEach(function (el) {
      var field = el.closest('.otcd-sm-apply__field');
      var bad = !el.value.trim() || (el.type === 'email' && !EMAIL.test(el.value.trim()));
      if (field) field.classList.toggle('invalid', bad);
      el.setAttribute('aria-invalid', bad ? 'true' : 'false');
      if (bad) {
        ok = false;
        first = first || el;
      }
    });

    if (moveFocus && first) first.focus();
    return ok;
  }

  // Re-check as the visitor fixes a field, without stealing focus.
  form.addEventListener('input', function (event) {
    var field = event.target.closest('.otcd-sm-apply__field');
    if (field && field.classList.contains('invalid')) check(false);
  });

  form.addEventListener('submit', function (event) {
    if (!check(true)) event.preventDefault();
  });

  // After the post redirects back, bring the confirmation into view.
  var done = form.querySelector('.otcd-sm-apply__done');
  if (done) done.focus();
})();
